import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import RevenuePage from "./pages/RevenuePage";
import ManagementPage from "./pages/ManagementPage";
import DebtPage from "./pages/DebtPage";
import DriverPage from "./pages/DriverPage";
import { useAuth } from "./hooks/useAuth";
import { useRevenueRows } from "./hooks/useRevenueRows";
import { useSheets } from "./hooks/useSheets";
import { DateScrollProvider } from "./contexts/DateScrollContext";

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <p className="text-slate-500">Đang tải...</p>
    </div>
  );
}

function RevenueAppPage() {
  const { user, authLoading, logout } = useAuth();
  const { rows, setRows, loading, error, loadData } = useRevenueRows(user);
  const { activeSheet } = useSheets(user);

  const normalizedRole = user?.role?.toLowerCase();
  const isDriver = normalizedRole === "driver";
  const isAccounting = normalizedRole === "accounting";
  const canViewDebt = isAccounting;
  // Kiểm tra is_locked: có thể là 1, true, hoặc "1"
  const isLocked = activeSheet?.is_locked === 1 || activeSheet?.is_locked === true || activeSheet?.is_locked === "1";

  // Tự động reload dữ liệu khi đổi tháng (activeSheet thay đổi)
  useEffect(() => {
    if (activeSheet && !isDriver) {
      loadData();
    }
  }, [activeSheet?.id, isDriver, loadData]);

  if (authLoading) return <LoadingScreen />;

  // Not logged in -> về trang login chung của client
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <DateScrollProvider>
      <Routes>
        {isDriver ? (
          <>
            <Route path="driver" element={<DriverPage user={user} />} />
            <Route path="*" element={<Navigate to="driver" replace />} />
          </>
        ) : (
          <Route
            element={
              <MainLayout
                user={user}
                onLogout={logout}
                loading={loading}
                authLoading={authLoading}
                canViewDebt={canViewDebt}
                onRefresh={loadData}
                rows={rows}
              />
            }
          >
          <Route
            index
            element={
              <RevenuePage
                rows={rows}
                onRowsChange={setRows}
                loading={loading}
                error={error}
                userRole={user.role}
                onRefresh={loadData}
                isLocked={isLocked}
              />
            }
          />
          <Route
            path="manage"
            element={<ManagementPage rows={rows} userRole={user.role} />}
          />
          <Route
            path="debt"
            element={
              canViewDebt ? (
                <DebtPage rows={rows} />
              ) : (
                <Navigate to="." replace />
              )
            }
          />
          <Route path="*" element={<Navigate to="." replace />} />
        </Route>
      )}
    </Routes>
    </DateScrollProvider>
  );
}

export default RevenueAppPage;

